
export default function FinalCTA() {
  const whatsappMessage = encodeURIComponent('Hola, me gustaría agendar una asesoría personalizada para invertir en los mercados financieros.');
  const whatsappLink = `https://wa.me/593981562448?text=${whatsappMessage}`;

  return (
    <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-black via-[#0A1A35] to-black">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <h2 className="text-4xl md:text-5xl font-bold text-white">
          Agenda una <span className="text-[#D4AF37]">asesoría personalizada</span>
        </h2>

        <p className="text-xl text-[#C5C7D0] leading-relaxed">
          Obtén un análisis claro, números reales y una estrategia diseñada para tus objetivos financieros.
        </p>

        <div className="pt-6">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-12 py-5 bg-[#D4AF37] text-black text-lg font-semibold rounded-lg hover:bg-[#A87E10] transition-all duration-300 shadow-2xl hover:shadow-[#D4AF37]/50 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Hablar por WhatsApp ahora
          </a>
        </div>

        <p className="text-[#C5C7D0]/60 text-sm pt-4">
          Respuesta en menos de 24 horas
        </p>
      </div>
    </section>
  );
}
